<template>
  <div class="promo-codes-container">
    <v-card flat class="futuristic-card">
      <div class="card-header">
        <h1 class="text-md-center earth-color">PROMO CODES</h1>
        <div class="title-decoration"></div>
      </div>
      <v-card-title>
        <v-spacer></v-spacer>
        <v-text-field
          append-icon="search"
          placeholder="Search promo codes..."
          single-line
          hide-details
          v-model="search"
          class="futuristic-input"
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="columns"
        :items="$allPromoCodesActive"
        :search="search"
        :rows-per-page-items="[10, 25, { text: 'All', value: -1 }]"
        :disable-initial-sort="true"
        :loading="$loadingTrue"
        class="futuristic-table"
      >
        <v-progress-linear
          slot="progress"
          color="#587e27"
          indeterminate
          height="3"
        ></v-progress-linear>
        <template slot="items" slot-scope="props">
          <td>{{ formated_date_time(props.item.created_at) }}</td>
          <td>{{ props.item.start_date }} to {{ props.item.end_date }}</td>
          <td class="font-weight-medium">{{ props.item.code }}</td>
          <td>{{ props.item.promo_code_type }}</td>
          <td>{{ props.item.max_uses }}</td>
          <td v-if="props.item.amount_discount === true">{{ props.item.amount_off_currency_name }} {{ props.item.amount_off }}</td>
          <td v-if="props.item.percentage_discount === true">{{ props.item.percentage_off }}%</td>
          <td>
            <v-btn
              depressed
              small
              color="#ef5350"
              class="futuristic-btn action-btn"
              @click="deletePromoCode(props.item.public_id)"
            >
              Delete
            </v-btn>
            <router-link :to="{name: 'PromoCodeUsage', params: {promo_code_id: props.item.public_id}}">
              <v-btn
                depressed
                small
                color="#2196f3"
                class="futuristic-btn action-btn"
              >
                View Usage
              </v-btn>
            </router-link>
          </td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning" class="futuristic-alert">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'promo-codes',
  data () {
    return {
      search: '',
      dialog: false,
      v_table: true,
      modal1: false,
      modal2: false,
      dialog1: false,
      promo_code: {
        session_id: '',
        start_date: '',
        end_date: '',
        percentage_off: '',
        max_uses: ''
      },
      columns: [
        {
          text: 'Added On',
          value: 'created_at',
          class: 'table-header'
        },
        {
          text: 'Duration',
          value: '',
          class: 'table-header'
        },
        {
          text: 'Code',
          value: 'last_name',
          class: 'table-header'
        },
        {
          text: 'Code Type',
          value: 'promo_code_type',
          class: 'table-header'
        },
        {
          text: 'Maximum Uses',
          value: 'max_uses',
          class: 'table-header'
        },
        {
          text: 'Percentage Off',
          value: 'percentage_off',
          class: 'table-header'
        },
        {
          text: 'Action',
          value: '',
          class: 'table-header'
        }
      ]
    }
  },
  created () {
    this.$store.dispatch('get_promo_codes')
  },
  methods: {
    deletePromoCode (promoCodeId) {
      this.$store.dispatch('delete_promo_code', promoCodeId)
      this.$store.dispatch('get_promo_codes')
    },
    deleteAuthorizer (publicId) {
      var data = {
        deleted_by: localStorage.getItem('lkjhgfdsa'),
        public_id: publicId
      }
      this.$store.dispatch('delete_staff', data)
    },
    updateAuthorizer (publicId) {
      this.$router.push({
        name: 'EditStaff',
        params: {
          staff_id: publicId
        }
      })
    }
  }
}
</script>

<style scoped>
/* Futuristic Container */
.promo-codes-container {
  background: #ffffff;
  border-radius: 8px;
  padding: 16px;
  transition: all 0.3s ease;
}

.promo-codes-container:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.card-header {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.earth-color {
  color: #587e27;
  font-weight: 600;
  margin: 0;
  font-size: 2rem;
}

.title-decoration {
  height: 4px;
  background: linear-gradient(90deg, #587e27, transparent);
  margin-bottom: 16px;
  width: 100px;
}

.futuristic-card {
  border-radius: 8px;
  background: #ffffff;
  transition: all 0.3s ease;
  overflow: hidden;
}

.futuristic-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.futuristic-input >>> .v-input__slot {
  border-radius: 8px;
  background: #f5f7fa;
}

.futuristic-btn {
  border-radius: 8px;
  text-transform: none;
  font-weight: 500;
  transition: all 0.2s ease;
}

.futuristic-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.action-btn {
  margin: 4px;
}

.futuristic-alert {
  border-radius: 8px;
  margin: 16px;
}

/* Table styling */
.futuristic-table >>> thead tr th {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa) !important;
  color: #587e27 !important;
  font-weight: 600;
  font-size: 14px;
}

.futuristic-table >>> tbody tr:nth-of-type(even) {
  background-color: #f9f9f9;
}

.futuristic-table >>> tbody tr:hover {
  background-color: #f0f4f8 !important;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .promo-codes-container {
    padding: 12px;
  }

  .card-header {
    padding: 12px;
  }

  .earth-color {
    font-size: 1.75rem;
  }

  .action-btn {
    margin: 2px;
  }
}

@media (max-width: 600px) {
  .promo-codes-container {
    padding: 8px;
    border-radius: 6px;
  }

  .card-header {
    padding: 8px;
  }

  .earth-color {
    font-size: 1.5rem;
  }
}
</style>